import "./lang_switch.scss"; import "./print/lang_switch.scss"

